<template>
  <div>
    <el-alert
      :key="item.id"
      v-for="item in alerts"
      :title="item.message"
      type="danger"
      center
      @close="close(item.id)"
      style="padding-left: 30px; color: white; font-size: 10px"
      :style="{ background: item.color }"
    >
    </el-alert>
  </div>
</template>
<script>
import ApiService from "@/services/ApiService";
export default {
  name: "AdminAlerts",
  data() {
    return {
      alerts: [],
    };
  },
  methods: {
    close(id) {
      ApiService.generalApi.hideAlert(id);
    },
    getAlerts() {
      ApiService.generalApi.getAlerts().then((response) => {
        this.alerts = response.data;
      });
    },
  },
  mounted() {
    // this.getAlerts();
  },
};
</script>
